export function throwErrorInline(message?: string): never {
  throw Error(message)
}

export function throwInline(obj: any): never {
  throw obj
}
